import { parse } from 'date-fns';

export default function testAgeValid (member, activeCategory) {
  const dateofBirth = parse(member.dateOfBirth, 'yyyy-MM-dd', new Date())
  const age = new Date().getFullYear() - dateofBirth.getFullYear();
  const ageValidity = age >= activeCategory.minAge && age <= activeCategory.maxAge;
  return { ageValidity, age, dateofBirth }
}